<template>
  <div class="big-box">
    <div class="scroll-box">
      <div>
        <div
          class="big-box-img"
          :style="{
            'background-image': `url(${
              ruleForm.checkInMode == 0
                ? bgUrl
                : backgroundImage
            })`,
            filter: ruleForm.checkInMode == 1 ? 'blur(50px)' : 'none',
            'background-size': ruleForm.checkInMode == 1 ? 'cover' : '',
          }"
        ></div>
        <div class="big-body">
          <img :src="tapTopUrl" alt="" class="tap-top" />
          <div class="theme" :style="{ color: ruleForm.wordColor }">
            {{ ruleForm.theme }}
          </div>
          <div
            class="desc"
            :style="{ color: ruleForm.wordColor }"
            style="opacity: 0.6"
          >
            {{ ruleForm.description }}
          </div>

          <template v-if="ruleForm.checkInMode == 0">
            <div style="font-size: 8px; color: #666666; margin: 41px 0 13px 0">
              活动距开始
              <span class="time-box">30</span>
              天
              <span class="time-box">23</span>:
              <span class="time-box">59</span>:
              <span class="time-box">59</span>
            </div>

            <div class="screen-box">
              <img
                v-if="ruleForm.screenCoverImage"
                :src="ruleForm.screenCoverImage"
                style="width: 100%; height: 100%"
              />
              <div v-else style="height: 251px"></div>
              <div
                style="
                  width: 100%;
                  height: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  background: rgba(0, 0, 0, 0.35);
                  position: absolute;
                  left: 0;
                  top: 0;
                "
              >
                <img :src="lock" style="width: 39px; height: 39px" />
              </div>
            </div>

            <div
              class="apply-progess"
              :style="{ backgroundImage: `url(${applyProgressBg})` }"
            >
              <div
                style="
                  color: #5f3a17;
                  width: 50px;
                  margin: 0 13px 0 15px;
                  line-height: 12px;
                "
              >
                {{ ruleForm.tagApplyNum }}人报名即可解锁
              </div>
              <div
                style="width: 116px; height: 8px; border-radius: 9px"
                :style="{ backgroundColor: ruleForm.progressBgColor }"
              >
                <div
                  :style="{
                    width: '50px',
                    height: '4px',
                    margin: '2px 0 0 1px',
                    'border-radius': '19px',
                    backgroundColor: ruleForm.progressColor,
                  }"
                ></div>
              </div>
              <img
                :src="heart"
                style="width: 18px; height: 18px; margin-left: -70px"
              />
              <div style="margin-left: 60px">0/{{ ruleForm.tagApplyNum }}</div>
            </div>
          </template>

          <div v-if="ruleForm.checkInMode == 1 && pictureList.length">
            <!-- 手机 -->
            <div class="phone-box" v-show="activeItem.type == 'phone'">
              <img :src="baseUrl + 'phone-bg.png'" class="img-frame" />
              <div
                :style="{
                  backgroundImage: `url(${activeItem.compressedImageUrl})`,
                }"
                class="wallpaper-box"
              ></div>
              <div class="phone-dot"></div>
              <div
                style="
                  width: 99%;
                  height: 98%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  background: rgba(0, 0, 0, 0.35);
                  position: absolute;
                  left: 0;
                  top: 0;
                  border-radius: 23px;
                "
              >
                <img :src="lock" style="width: 39px; height: 39px" />
              </div>
            </div>
            <!-- ipad -->
            <div class="ipad-box" v-show="activeItem.type == 'ipad'">
              <img :src="baseUrl + 'ipad-bg.png'" class="img-frame" />
              <div
                :style="{
                  backgroundImage: `url(${activeItem.compressedImageUrl})`,
                }"
                class="wallpaper-box"
              ></div>
              <div
                style="
                  width: 100%;
                  height: 98%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  background: rgba(0, 0, 0, 0.35);
                  position: absolute;
                  left: 0;
                  top: 0;
                  border-radius: 23px;
                "
              >
                <img :src="lock" style="width: 39px; height: 39px" />
              </div>
            </div>
            <!-- 电脑 -->
            <div class="computer-box" v-show="activeItem.type == 'computer'">
              <img :src="baseUrl + 'computer-bg.png'" class="img-frame" />
              <div
                :style="{
                  backgroundImage: `url(${activeItem.compressedImageUrl})`,
                }"
                class="wallpaper-box"
              ></div>
              <div
                style="
                  width: 100%;
                  height: 72%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  background: rgba(0, 0, 0, 0.35);
                  position: absolute;
                  left: 0;
                  top: 0;
                "
              >
                <img :src="lock" style="width: 39px; height: 39px" />
              </div>
            </div>

            <!-- 底部列表 -->
            <div
              style="
                width: 100%;
                bottom: 10px;
                display: flex;
                justify-content: center;
              "
            >
              <div
                class="bottom-paper-list"
                :style="{
                  'padding-left': pictureList.length >= 6 ? '20px' : '',
                }"
              >
                <div
                  :class="[
                    activeItem.compressedImageUrl == item.compressedImageUrl
                      ? 'list-item-active'
                      : 'list-item',
                  ]"
                  v-for="(item, index) in pictureList"
                  :key="index"
                  @click="selectImg(item)"
                >
                  <el-image
                    :src="item.compressedImageUrl"
                    class="list-item-bg"
                    fit="cover"
                    :lazy="true"
                  ></el-image>
                  <div class="paper-title">
                    {{
                      item.type == "phone"
                        ? "手机"
                        : item.type == "ipad"
                        ? "平板"
                        : "电脑"
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div
              style="
                font-size: 8px;
                color: #1a1a1a;
                margin: 7px 0;
                text-align: center;
              "
            >
              活动距开始
              <span class="time-box2">30</span>
              天
              <span class="time-box2">23</span>:
              <span class="time-box2">59</span>:
              <span class="time-box2">59</span>
            </div>
          </div>

          <div
            class="main-button"
            :style="{
              'background-image': `url(${ruleForm.buttonBackgroundColor})`,
              color: ruleForm.buttonWordColor,
            }"
          >
            立即报名
          </div>

          <div
            v-if="ruleForm.isSurprisePrize == 1 && ruleForm.checkInMode == 0"
            style="
              width: 256px;
              height: 127px;
              background: #ffffff;
              border-radius: 9px;
            "
          >
            <div class="suprise-text">惊喜礼品</div>
            <div class="prize-box-item" v-if="selectPrize">
              <img
                v-if="selectPrize.logo"
                :src="selectPrize.logo"
                style="
                  width: 78px;
                  height: 78px;
                  margin-right: 8px;
                  border-radius: 5px;
                "
              />
              <div style="width: 100%; position: relative; min-height: 83px">
                <template v-if="selectPrize.title">
                  <div style="font-size: 11px; margin-top: 5px">
                    {{ selectPrize.title }}
                  </div>
                  <div
                    style="
                      font-size: 9px;
                      padding: 2px 6px;
                      border: 1px solid #e1e1e1;
                      border-radius: 2px;
                      width: fit-content;
                      color: #999999;
                      margin: 7px 0 20px 0;
                    "
                  >
                    剩余{{ selectPrize.totalAmount }}份
                  </div>
                  <div style="color: #f8304b">
                    <span style="font-size: 8px; margin-right: 2px">价值</span>
                    <span style="font-size: 14px">{{ selectPrize.price }}</span>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <img
        v-if="ruleForm.showMoreList == '1'"
        class="more-activity"
        :src="
          ruleForm.showMoreListUrl ||
          $globalCdn + '/images/preview/more_activity.png'
        "
        alt=""
      />
    </div>
    <div class="title" v-if="!oneShow">图为预览效果，以实际投效果为准</div>
  </div>
</template>
<script>
const $globalCdn = "https://cdn-image.yucrm.cn/images/dyAssets"
export default {
  name: "",
  components: {},
  mixins: [],
  props: {
    ruleForm: {
      type: Object,
      default: () => ({}),
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    oneShow: {
      type: Boolean,
      default: false,
    },
    baseUrl: {
      type: String,
      default: "",
    },
    cusTemplateJSON: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      tapTopUrl: $globalCdn + "/images/preview/shop_top.png",
      lock: this.baseUrl + "lock.png",
      heart: this.baseUrl + "heart.png",
      applyProgressBg: this.baseUrl + "apply_progress_bg.png",
      activeItem: null,
      backgroundImage: "",
    };
  },
  computed: {
    selectPrize() {
      if (this.ruleForm.tableData.length > 0) {
        return this.ruleForm.tableData[0];
      }
      return null;
    },
    wallpaperList() {
      return this.ruleForm.wallpaperList;
    },
    ipadWallpaperList() {
      return this.ruleForm.ipadWallpaperList;
    },
    pcWallpaperList() {
      return this.ruleForm.pcWallpaperList;
    },
    pictureList() {
      let arr = [
        ...this.ruleForm.wallpaperList,
        ...this.ruleForm.ipadWallpaperList,
        ...this.ruleForm.pcWallpaperList,
      ];
      return arr;
    },
    bgUrl() { //更换背景图
      return this.cusTemplateJSON  ? JSON.parse(this.cusTemplateJSON).activityBgImg : this.ruleForm.backgroundImage;
    }
  },
  watch: {
    pictureList: {
      handler(val) {
        console.log(val,'565465445456');
        
        if (val.length > 0) {
          this.activeItem = val[0];
          this.backgroundImage = this.pictureList[0].compressedImageUrl;
        }
      },
    },
  },
  mounted() {},
  methods: {
    selectImg(item) {
      if (
        !item ||
        this.activeItem.compressedImageUrl == item.compressedImageUrl
      )
        return;
      this.backgroundImage = item.compressedImageUrl;
      this.activeItem = item;
    },
  },
};
</script>
<style lang="scss" scoped>
.big-box {
  position: relative;
  width: 300px;
  height: 580px;
  box-shadow: 0px 4px 20px 0px rgba(18, 10, 60, 0.15);
  border-radius: 24px;
  border: 1px solid #ffffff;
  padding: 8px;
  margin-left: 231px;
  z-index: 1;
  background-color: #ffffff;
  // overflow: auto;
  // 隐藏滚动条

  .scroll-box {
    overflow: auto;
    height: 560px;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      width: 0 !important;
    }
    -ms-overflow-style: none;
    border-radius: 24px;
  }

  // overflow: hidden;
  .big-box-img {
    border-radius: 24px;
    width: 283px;
    height: 755px;
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .big-body {
    // position: absolute;
    // top: 0;
    // left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    // overflow: hidden;
    margin-top: -760px;
    position: relative;

    .btn-box {
      width: 177px;
      height: 34px;
      position: relative;
      // position: absolute;
      // top: 480px;

      .btn-box-text {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: 12px;
        font-weight: bold;
      }
    }

    .tap-top {
      margin-top: 8px;
    }
    .theme {
      font-weight: 600;
      font-size: 16px;
      margin-top: 14px;
      text-transform: none;
    }
    .desc {
      margin: 12px auto;
      // width: 170px;
      height: 10px;
      font-weight: 400;
      font-size: 11px;
      text-align: center;
      line-height: 10px;
      font-style: normal;
      text-transform: none;
    }
  }
  .more-activity {
    position: absolute;
    width: 60px;
    height: 60px;
    bottom: 125px;
    right: 6px;
  }
  .title {
    margin-top: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 14px;
    text-align: center;
  }
}
.main-button {
  width: 219px;
  height: 37px;
  font-size: 12px;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 13px;
  font-weight: bold;
}
.time-box {
  color: #ffffff;
  border-radius: 2px;
  margin: 0 2px;
  background: linear-gradient(136deg, #797162 0%, #373125 100%);
  padding: 2px;
}
.screen-box {
  width: 251px;
  // height: 251px;
  // background: rgba(0, 0, 0, 0.35);
  border-radius: 9px 9px 9px 9px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
}
.apply-progess {
  font-size: 8px;
  width: 251px;
  height: 48px;
  display: flex;
  align-items: center;
  margin: 6px 0 13px 0;
  border-radius: 9px 9px 9px 9px;
  background-size: 100% 100%;
}
.prize-box {
  padding: 6px;
  margin-top: 16px;
  display: flex;
  flex-direction: row;

  &-item {
    padding: 0 12px;
    display: flex;
    flex-direction: row;
    border-radius: 0 0 6px 6px;
  }
}
.suprise-text {
  color: #bda283;
  font-size: 12px;
  margin: 12px 0;
  text-align: center;
  font-weight: bold;
}
.phone-box {
  position: relative;
  width: 139px;
  margin: 5px auto 16px auto;
  .img-frame {
    width: 139px;
    height: 287px;
  }
  .wallpaper-box {
    position: absolute;
    left: 6px;
    width: 128px;
    height: 278px;
    top: 5px;
    border-radius: 16px;
    background-size: cover;
    background-position: center;
  }
  .phone-dot {
    background: #000000;
    width: 38px;
    height: 12px;
    position: absolute;
    top: 8px;
    left: 52px;
    border-radius: 40px;
  }
}
.ipad-box {
  position: relative;
  width: 248px;
  margin: 38px auto 81px auto;
  .img-frame {
    width: 248px;
    height: 189px;
  }
  .wallpaper-box {
    position: absolute;
    left: 8px;
    width: 231px;
    height: 173px;
    top: 8px;
    border-radius: 3px;
    background-size: cover;
    background-position: center;
  }
}
.computer-box {
  position: relative;
  width: 266px;
  margin: 51px auto 49px auto;
  .img-frame {
    width: 266px;
    height: 208px;
  }
  .wallpaper-box {
    position: absolute;
    left: 3px;
    width: 259px;
    height: 146px;
    top: 3px;
    background-size: cover;
    background-position: center;
  }
}
.bottom-paper-list {
  max-width: 100%;
  // position: absolute;
  // bottom: 10px;
  // padding-left: 20px;
  // white-space: nowrap;
  overflow: scroll;
  // 隐藏滚动条
  scrollbar-width: none;
  &::-webkit-scrollbar {
    width: 0 !important;
  }
  -ms-overflow-style: none;
  display: flex;
  flex-wrap: nowrap;
  height: 71px;

  .list-item-active {
    width: 51px;
    height: 68px;
    margin-right: 10px;
    box-shadow: 4px 4px 15px 0px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    border: 1px solid #ffffff;
    position: relative;
  }
  .list-item {
    width: 51px;
    height: 68px;
    margin-right: 10px;
    box-shadow: 4px 4px 15px 0px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    position: relative;
    // overflow: hidden;
  }
  .list-item-bg {
    border-radius: 6px;
    overflow: hidden;
    width: 49px;
    height: 66px;
    background-size: cover;
    background-position: center;
  }
  .paper-title {
    background: rgba(0, 0, 0, 0.3);
    color: #fff;
    font-size: 10px;
    position: absolute;
    bottom: 0;
    width: 49px;
    padding: 2px;
    text-align: center;
    border-radius: 0 0 6px 6px;
  }
}
.time-box2 {
  background: rgba(255, 255, 255, 0.35);
  border-radius: 2px 2px 2px 2px;
  border: 0px solid rgba(255, 255, 255, 0.7);
  padding: 2px;
}
</style>
